import { render, staticRenderFns } from "./welfareCenter.vue?vue&type=template&id=6a5e0d38&scoped=true&"
import script from "./welfareCenter.ts?vue&type=script&lang=js&"
export * from "./welfareCenter.ts?vue&type=script&lang=js&"
import style0 from "./welfareCenter.less?vue&type=style&index=0&id=6a5e0d38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e0d38",
  null
  
)

export default component.exports